import { Button, EmptyState } from '@ibe/ui';
import { Link } from 'react-router-dom';

/** An unknown route. Offers a way back rather than a dead end. */
export function NotFoundPage(): React.JSX.Element {
  return (
    <EmptyState
      title="That page does not exist"
      description="The link may be out of date, or the record may have been removed."
      action={
        <Button asChild variant="outline">
          <Link to="/dashboard">Back to the dashboard</Link>
        </Button>
      }
    />
  );
}
